import { render, staticRenderFns } from "./TftUniversityShowdownLeaderboard.vue?vue&type=template&id=00d8635c&"
import script from "./TftUniversityShowdownLeaderboard.vue?vue&type=script&lang=js&"
export * from "./TftUniversityShowdownLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./TftUniversityShowdownLeaderboard.vue?vue&type=style&index=0&id=00d8635c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports